// @ts-nocheck
import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import { Route, Switch, useHistory } from "react-router";
import { RouteComponentProps } from "react-router-dom";
import { AuthenticationVerifier } from "../../components/auth-verifier";
import { AuthorizationVerifier } from "../../components/authorization-verifier";
import { ChainDataProvider } from "../../components/chain-data-provider";
import { FullWidthLoader } from "../../components/full-width-loader";
import { PropertyInventoriesProvider } from "../../components/inventory-provider";
import { LoyaltyBrandProvider } from "../../components/loyalty-brand-provider";
import { PropertyAdminDataProvider } from "../../components/property-admin-data-provider";
import { PropertyConfigurationProvider } from "../../components/property-configuration-provider";
import { usePropertyLocales } from "../../components/property-locale-provider";
import { PropertyProvider } from "../../components/property-provider";
import { useUserProfile } from "../../components/user-profile-provider";
import UserPropertyTickersProvider from "../../components/user-tickers-providers";
import { ClassicLayout } from "../../layout/classic";
import { useUserAuthInfo } from "../../lib/auth";
import { getLanguageFromFullLocale } from "../../lib/config";
import { SECTION } from "../../lib/constants";
import AccommodationCrud from "../accommodation";
import AnalyticsManager from "../analyticsManager";
import { ARIManagement } from "../ariManagement";
import { SortAndFilterContextProvider } from "../ariManagement/sortAndFilter/contexts/SortAndFilterContext";
import AriSnapshot from "../ariSnapshot";
import BatchInventory from "../batchInventory";
import BatchReservationCancellation from "../batchReservationCancellation";
import Behaviour from "../behaviour";
import BillingReport from "../billingReport";
import BundleCrud from "../bundle";
import EditBundle from "../bundle/EditBundle";
import ChainConfigurer from "../chain";
import ChannelManagerActivation from "../channelManager";
import ChannelReservationLogForm from "../ChannelReservationLog/ChannelReservationLog";
import CommunicationAlerts from "../communicationAlerts";
import CreateProperty from "../createProperty";
import CurrencyManager from "../currency";
import CustomMapsForm from "../customMaps";
import Dashboard from "../dashboard";
import AccordionMenu from "../defineInventory";
import Discrepancies from "../discrepancies";
import EngineAppearanceForm from "../engineAppeareance";
import AdvancedEngineAppearance from "../engineAppeareance/advancedEngineAppearance";
import EngineGuestDataForm from "../engineGuestData";
import GenerateBillingReport from "../generateBillingReport";
import GHALoyaltySwitch from "../ghaLoyaltySwitch";
import GTMManager from "../gtmManager";
import { HistoricalReservation } from "../historicalReservation";
import InventoryMultiUpdate from "../inventory/multiUpdate";
import InventoryTable from "../inventoryTable";
import LanguageManager from "../languages";
import LegalInfoCrud from "../legalinfo";
import { Login } from "../login";
import UpgradeTier from "../loyalty/upgradeTier";
import LoyaltyCustomerCrud from "../loyaltyCustomer";
import LoyaltyCustomerManager, { LoyaltyCustomerActionType } from "../loyaltyCustomerManager";
import LoyaltyCustomerTransactionReport from "../loyaltyCustomerTransactionReport";
import LoyaltyHistorical from "../loyaltyHistorical";
import LoyaltyLinksGenerator from "../loyaltyLinksGenerator";
import LoyaltyOrganizationCrud from "../loyaltyOrganization";
import LoyaltyTierCrud from "../loyaltyTier";
import MealPlanCrud from "../mealplan";
import MigrateReservation from "../migrateReservation";
import ReservationModificationForm from "../modification";
import OccupancyForm from "../occupancyTypes";
import OccupationCrud from "../occupation";
import PackageCrud from "../package";
import PropertyCalendarRegen from "../propertyCalendarRegen";
import PropertyCRUD from "../propertyInfo";
import QueryExecutor from "../queryExecutor";
import Quotation from "../quotation";
import ReplicateProperty from "../replicateProperty";
import Report, { ReportType } from "../report";
import { ReportQueries } from "../reportQueries";
import ReportStaysPerDay from "../reportStaysPerDay";
import ReservationCrud from "../reservation";
import ReservationDetail from "../reservationDetail";
import { TagsContextProvider } from "../tagsManager/TagContext";
import { TagsList } from "../tagsManager/TagsList";
import { TagsMultiUpdate } from "../tagsManager/TagsMultiUpdate";
import FeesCrud from "../taxation/fees";
import TaxesCrud from "../taxation/taxes";
import TaxConfigurationForm from "../taxConfiguration";
import UserManager, { UserManagerActionType } from "../userManager";
import VerifyUserManager from "../verifyUserManager";
import { WaitingListReport } from "../waitingListReport";
import WebMessageCRUD from "../webMessage";
import { TIER_TYPE } from "../witadmin/Common/constants";
import ConfigurationManager from "../witadmin/ConfigurationManager/ConfigurationManager";
import GoogleFeed from "../witadmin/CRUD/GoogleFeed/GoogleFeed";
import {
  CancellationPolicyForm,
  CancellationPolicyList,
  ClientsForm,
  ClientsList,
  ConditionsForm,
  ConditionsList,
  ContractsForm,
  ContractsList,
  DisplayForm,
  DisplayList,
  EmailTemplateForm,
  EmailTemplateList,
  FilterForm,
  FilterList,
  LegalInfoForm,
  LegalInfoList,
  ModificationForm,
  ModificationList,
  PartnersForm,
  PartnersList,
  PaymentTypesForm,
  PaymentTypesList,
  PromotionsForm,
  PromotionsList,
  PropertiesForm,
  PropertiesList,
  QuestionnaireForm,
  QuestionnaireList,
  ServicesForm,
  ServicesList,
} from "../witadmin/CRUD/rest";
import ForwardingReservations from "../witadmin/ForwardingReservations/ForwardingReservations";
import SelentaPriceFeedForm from "../witadmin/SelentaPriceFeed/SelentaPriceFeedForm";
import PromotionEditByExcel from "../promotions/edit-by-excel";
import EmailBlacklistManager from "../emailBlacklist";
import ExtrasCrud from "../extras";
import EditExtra from "../extras/EditExtra";
import EngineMultiConfig from "../engineMultiConfig";
import { ReportQueriesBak } from "../reportQueriesBak";

type TParams = { propertyTicker: string; success: string; id: string };

export default function Entry() {
  return (
    <Switch>
      <Route path="/login/:propertyTicker?">
        <AuthenticationVerifier propertyTicker="demo_soporte">
          <UserPropertyTickersProvider>
            <Login />
          </UserPropertyTickersProvider>
        </AuthenticationVerifier>
      </Route>

      <Route path="/crm">
        {({ match }: RouteComponentProps<TParams>) => (
          <AuthenticationVerifier propertyTicker="demo_soporte">
            <PropertyConfigurationProvider>
              <ClassicLayout>
                <CrmRoutes url={match!.url} />
              </ClassicLayout>
            </PropertyConfigurationProvider>
          </AuthenticationVerifier>
        )}
      </Route>

      <Route path="/internal">
        {({ match }: RouteComponentProps<TParams>) => (
          <AuthenticationVerifier propertyTicker="demo_soporte">
            <PropertyConfigurationProvider>
              <UserPropertyTickersProvider>
                <ClassicLayout currentPropertyTicker={match?.params.propertyTicker}>
                  <Switch>
                    <Route path={`${match!.url}/user-manager/create`}>
                      <UserManager
                        section={SECTION.CREATE_USER_BATCH}
                        action={UserManagerActionType.CREATE}
                      />
                    </Route>
                    <Route path={`${match!.url}/user-manager/edit`}>
                      <UserManager
                        section={SECTION.EDIT_USER_BATCH}
                        action={UserManagerActionType.EDIT}
                      />
                    </Route>
                    <Route path={`${match!.url}/user-manager/delete`}>
                      <UserManager
                        section={SECTION.PROPERTY_CHANNEL_MANAGERS}
                        action={UserManagerActionType.DELETE}
                      />
                    </Route>
                    <Route path={`${match!.url}/user-manager/replicate-property`}>
                      <ReplicateProperty
                        section={SECTION.REPLICATE_PROPERTY}
                        action={UserManagerActionType.CREATE}
                      />
                    </Route>
                    <Route path={`${match!.url}/user-manager/create-property`}>
                      <CreateProperty
                        section={SECTION.CREATE_PROPERTY}
                        action={UserManagerActionType.CREATE}
                      />
                    </Route>
                    <Route path={`${match!.url}/loyalty-customer-manager/remove`}>
                      <LoyaltyCustomerManager
                        section={SECTION.PROPERTY_CHANNEL_MANAGERS}
                        action={LoyaltyCustomerActionType.REMOVE_OR_ANONYMIZE}
                      />
                    </Route>
                    <Route path={`${match!.url}/verify-user-manager`}>
                      <VerifyUserManager section={SECTION.PROPERTY_CHANNEL_MANAGERS} />
                    </Route>
                    <Route path={`${match!.url}/chain`}>
                      <ChainConfigurer section={SECTION.CHAIN_CONFIGURER} />
                    </Route>
                    <Route path={`${match!.url}/discrepancies`}>
                      <Discrepancies section={SECTION.PROPERTY_CHANNEL_MANAGERS} />
                    </Route>
                    <Route path={`${match!.url}/channelManager`}>
                      <ChannelManagerActivation section={SECTION.PROPERTY_CHANNEL_MANAGERS} />
                    </Route>
                    <Route path={`${match!.url}/queryExecutor`}>
                      <QueryExecutor section={SECTION.QUERY_EXECUTOR} />
                    </Route>
                    <Route path={`${match!.url}/channelReservationLog`}>
                      <ChannelReservationLogForm section={SECTION.CHANNEL_LOGS} />
                    </Route>
                    <Route path={`${match!.url}/googleFeed`}>
                      <div className="witadmin-bs3 witadmin-bs3-parent">
                        <GoogleFeed section={SECTION.GOOGLE_FEED} />
                      </div>
                    </Route>
                    <Route path={`${match!.url}/forwardingReservations`}>
                      <div className="witadmin-bs3 witadmin-bs3-parent">
                        <ForwardingReservations section={SECTION.RESEND_RESERVATION_TO_CHANNEL} />
                      </div>
                    </Route>
                    <Route path={`${match!.url}/ari-snapshot`}>
                      <AriSnapshot section={SECTION.ARI_SNAPSHOT} />
                    </Route>
                    <Route path={`${match!.url}/property-calendar-regen`}>
                      <PropertyCalendarRegen section={SECTION.PROPERTY_CALENDAR_REGEN} />
                    </Route>
                    <Route path={`${match!.url}/migrate-reservation`}>
                      <MigrateReservation section={SECTION.MIGRATE_RESERVATION} />
                    </Route>
                  </Switch>
                </ClassicLayout>
              </UserPropertyTickersProvider>
            </PropertyConfigurationProvider>
          </AuthenticationVerifier>
        )}
      </Route>
      <Route path="/:propertyTicker">
        {({ match }: RouteComponentProps<TParams>) => (
          <>
            <AuthenticationVerifier propertyTicker={match?.params.propertyTicker}>
              <PropertyProvider
                propertyTicker={match?.params.propertyTicker}
                loader={<FullWidthLoader />}>
                <PropertyConfigurationProvider>
                  <LoyaltyBrandProvider propertyTicker={match?.params.propertyTicker}>
                    <UserPropertyTickersProvider>
                      <ChainDataProvider propertyTicker={match?.params.propertyTicker}>
                        <ClassicLayout currentPropertyTicker={match?.params.propertyTicker}>
                          <PropertyRoutes
                            propertyTicker={match?.params.propertyTicker}
                            url={match!.url}
                          />
                        </ClassicLayout>
                      </ChainDataProvider>
                    </UserPropertyTickersProvider>
                  </LoyaltyBrandProvider>
                </PropertyConfigurationProvider>
              </PropertyProvider>
            </AuthenticationVerifier>
          </>
        )}
      </Route>
    </Switch>
  );
}

interface PropertyRoutesProps {
  propertyTicker: string;
  url: string;
}

function CrmRoutes({ url }: { url: string }) {
  return (
    <Switch>
      <Route path={`${url}/clients`}>
        {({ match }: RouteComponentProps<TParams>) => (
          <WitAdminCrudRoutes
            propertyTicker="crm"
            url={match!.url}
            ListComponent={ClientsList}
            FormComponent={ClientsForm}
            section={SECTION.CRM_CLIENT}
          />
        )}
      </Route>
      <Route path={`${url}/contracts`}>
        {({ match }: RouteComponentProps<TParams>) => (
          <WitAdminCrudRoutes
            propertyTicker="crm"
            url={match!.url}
            ListComponent={ContractsList}
            FormComponent={ContractsForm}
            section={SECTION.CRM_CONTRACT}
          />
        )}
      </Route>
      <Route path={`${url}/properties`}>
        {({ match }: RouteComponentProps<TParams>) => (
          <WitAdminCrudRoutes
            propertyTicker="crm"
            url={match!.url}
            ListComponent={PropertiesList}
            FormComponent={PropertiesForm}
            section={SECTION.CRM_PROPERTY}
          />
        )}
      </Route>
      <Route path={`${url}/services`}>
        {({ match }: RouteComponentProps<TParams>) => (
          <WitAdminCrudRoutes
            propertyTicker="crm"
            url={match!.url}
            ListComponent={ServicesList}
            FormComponent={ServicesForm}
            section={SECTION.CRM_SERVICE}
          />
        )}
      </Route>
      <Route path={`${url}/partners`}>
        {({ match }: RouteComponentProps<TParams>) => (
          <WitAdminCrudRoutes
            propertyTicker="crm"
            url={match!.url}
            ListComponent={PartnersList}
            FormComponent={PartnersForm}
            section={SECTION.CRM_PARTNER}
          />
        )}
      </Route>
      <Route path={`${url}/generate`}>
        <GenerateBillingReport section={SECTION.GENERATE_BILLING_REPORT} />
      </Route>
    </Switch>
  );
}

function PropertyRoutes({ propertyTicker, url }: PropertyRoutesProps) {
  const userAuthInfo = useUserAuthInfo();
  const userProfile = useUserProfile();
  const loader = useMemo(() => <FullWidthLoader />, []);

  return (
    <Switch>
      <Route path={`${url}/gha-loyalty-switch`}>
        <LoyaltyBrandProvider propertyTicker={propertyTicker}>
          <ChainDataProvider propertyTicker={propertyTicker}>
            <GHALoyaltySwitch section={SECTION.MAIN_INTERNAL_INTEGRATIONS} />
          </ChainDataProvider>
        </LoyaltyBrandProvider>
      </Route>
      <Route path={`${url}/loyalty-links-generator`}>
        <LoyaltyBrandProvider propertyTicker={propertyTicker}>
          <ChainDataProvider propertyTicker={propertyTicker}>
            <LoyaltyLinksGenerator propertyTicker={propertyTicker} />
          </ChainDataProvider>
        </LoyaltyBrandProvider>
      </Route>
      <Route path={`${url}/loyalty-customer-manager/import`}>
        <LoyaltyCustomerManager
          section={SECTION.PROPERTY_CHANNEL_MANAGERS}
          action={LoyaltyCustomerActionType.IMPORT}
        />
      </Route>
      <Route path={`${url}/define-inventory`}>
        <AccordionMenu propertyTicker={propertyTicker} />
      </Route>
      <Route path={`${url}/dashboard`}>
        <ChainDataProvider propertyTicker={propertyTicker}>
          <Dashboard propertyTicker={propertyTicker} section={SECTION.DASHBOARD} />
        </ChainDataProvider>
      </Route>
      <Route path={`${url}/accommodations`}>
        <PropertyAdminDataProvider loader={loader} loadInventories>
          <AccommodationCrud propertyTicker={propertyTicker} section={SECTION.ACCOMMODATIONS} />
        </PropertyAdminDataProvider>
      </Route>
      <Route path={`${url}/tax-configuration`}>
        <TaxConfigurationForm section={SECTION.TAX_CONFIGURATION} />
      </Route>
      <Route path={`${url}/engine-appearance`}>
        <EngineAppearanceForm
          propertyTicker={propertyTicker}
          section={SECTION.APPEARANCE_SETTINGS}
        />
      </Route>
      <Route path={`${url}/advanced-engine-appearance`}>
        <AdvancedEngineAppearance section={SECTION.APPEARANCE_SETTINGS} witAdminRequired={true} />
      </Route>
      <Route path={`${url}/engine-multi-config`}>
        <EngineMultiConfig section={SECTION.APPEARANCE_SETTINGS} witAdminRequired={true} />
      </Route>
      <Route path={`${url}/gtm-manager`}>
        <GTMManager section={SECTION.GTM_MANAGER} />
      </Route>
      <Route path={`${url}/email-blacklist`}>
        <EmailBlacklistManager propertyTicker={propertyTicker} section={SECTION.EMAIL_BLACKLIST} />
      </Route>
      <Route path={`${url}/packages`}>
        <PropertyAdminDataProvider loader={loader} loadInventories>
          <PackageCrud propertyTicker={propertyTicker} section={SECTION.PACKAGES} />
        </PropertyAdminDataProvider>
      </Route>
      <Route path={`${url}/bundles`}>
        <PropertyAdminDataProvider loader={loader} loadInventories>
          <BundleCrud propertyTicker={propertyTicker} section={SECTION.BUNDLES} />
        </PropertyAdminDataProvider>
      </Route>
      <Route path={`${url}/bundles-edit`}>
        <PropertyAdminDataProvider loader={loader} loadInventories>
          <EditBundle section={SECTION.BUNDLES_EDIT} />
        </PropertyAdminDataProvider>
      </Route>
      <Route path={`${url}/bundles-new`}>
        <PropertyAdminDataProvider loader={loader} loadInventories>
          <EditBundle section={SECTION.BUNDLES_CREATE} />
        </PropertyAdminDataProvider>
      </Route>
      <Route path={`${url}/mealplan`}>
        <MealPlanCrud propertyTicker={propertyTicker} section={SECTION.MEAL_PLANS} />
      </Route>
      <Route path={`${url}/occupation`}>
        <OccupationCrud propertyTicker={propertyTicker} section={SECTION.OCCUPATIONS} />
      </Route>
      <Route path={`${url}/web-message`}>
        <WebMessageCRUD propertyTicker={propertyTicker} section={SECTION.WEB_MESSAGES} />
      </Route>
      <Route path={`${url}/property-info`}>
        <PropertyCRUD propertyTicker={propertyTicker} section={SECTION.PROPERTY_INFO} />
      </Route>
      <Route path={`${url}/reservationModification`}>
        <PropertyInventoriesProvider propertyTickers={[propertyTicker]}>
          <ReservationModificationForm
            propertyTicker={propertyTicker}
            section={SECTION.RESERVATIONS_LIST}
          />
        </PropertyInventoriesProvider>
      </Route>
      <Route path={`${url}/historical`}>
        <PropertyInventoriesProvider propertyTickers={[propertyTicker]}>
          <HistoricalReservation propertyTicker={propertyTicker} />
        </PropertyInventoriesProvider>
      </Route>
      <Route path={`${url}/reservations`}>
        <PropertyInventoriesProvider propertyTickers={[propertyTicker]}>
          <ReservationCrud
            multiProperty={false}
            propertyTicker={propertyTicker}
            url={url}
            email={userProfile?.email}
          />
        </PropertyInventoriesProvider>
      </Route>
      <Route path={`${url}/reservation-detail`}>
        <ReservationDetail propertyTicker={propertyTicker} section={SECTION.RESERVATIONS_LIST} />
      </Route>
      <Route path={`${url}/quotation`}>
        <UserPropertyTickersProvider>
          <Quotation section={SECTION.QUOTATION} />
        </UserPropertyTickersProvider>
      </Route>
      <Route path={`${url}/loyalty-tiers-constant`}>
        <LoyaltyTierCrud
          propertyTicker={propertyTicker}
          tierType={TIER_TYPE.CONSTANT}
          section={SECTION.LOYALTY_CONSTANT_TIERS}
        />
      </Route>
      <Route path={`${url}/loyalty-tiers-derived`}>
        <LoyaltyTierCrud
          propertyTicker={propertyTicker}
          tierType={TIER_TYPE.DERIVED}
          section={SECTION.LOYALTY_DERIVED_TIERS}
        />
      </Route>
      <Route path={`${url}/loyalty-customers`}>
        <LoyaltyCustomerCrud
          propertyTicker={propertyTicker}
          section={SECTION.LOYALTY_CUSTOMERS}
          email={userProfile?.email}
        />
      </Route>
      <Route path={`${url}/loyalty-organizations`}>
        <LoyaltyOrganizationCrud
          propertyTicker={propertyTicker}
          section={SECTION.LOYALTY_ORGANIZATIONS}
        />
      </Route>
      <Route path={`${url}/loyalty-customer-transaction-report`}>
        <LoyaltyCustomerTransactionReport section={SECTION.LOYALTY_CUSTOMER_TRANSACTION_REPORT} />
      </Route>
      <Route path={`${url}/loyalty-historical`}>
        <LoyaltyHistorical section={SECTION.LOYALTY_HISTORICAL} />
      </Route>
      <Route path={`${url}/taxes`}>
        <TaxesCrud propertyTicker={propertyTicker} section={SECTION.TAXES_MANAGER} />
      </Route>
      <Route path={`${url}/fees`}>
        <FeesCrud propertyTicker={propertyTicker} section={SECTION.FEES_MANAGER} />
      </Route>
      <Route path={`${url}/upgrade-tier`}>
        <UpgradeTier section={SECTION.UPGRADE_TIER} />
      </Route>
      <Route path={`${url}/reservationsMulti`}>
        <ReservationCrud
          multiProperty
          propertyTicker={propertyTicker}
          url={url}
          email={userProfile?.email}
        />
      </Route>
      <Route path={`${url}/legalInfo`}>
        {({ match }: RouteComponentProps<TParams>) => (
          <PropertyAdminDataProvider loader={loader}>
            <WitAdminCrudRoutes
              url={match!.url}
              propertyTicker={propertyTicker}
              ListComponent={LegalInfoList}
              FormComponent={LegalInfoForm}
              section={SECTION.LEGAL_INFO}
            />
          </PropertyAdminDataProvider>
        )}
      </Route>
      <Route path={`${url}/promotions`}>
        {({ match }: RouteComponentProps<TParams>) => (
          <PropertyAdminDataProvider loader={loader} loadInventories loadPromoLegacyMapping>
            <ChainDataProvider propertyTicker={propertyTicker}>
              {result => {
                const { children = [] } = result || {};
                return (
                  <PropertyInventoriesProvider propertyTickers={children}>
                    <WitAdminCrudRoutes
                      url={match!.url}
                      propertyTicker={propertyTicker}
                      ListComponent={PromotionsList}
                      FormComponent={PromotionsForm}
                      section={SECTION.PROMOTIONS}
                    />
                  </PropertyInventoriesProvider>
                );
              }}
            </ChainDataProvider>
          </PropertyAdminDataProvider>
        )}
      </Route>
      <Route path={`${url}/promotions-xlsx/:id`}>
        {({ match, ...props }: RouteComponentProps<TParams>) => (
          <PropertyAdminDataProvider loader={loader} loadInventories loadPromoLegacyMapping>
            <ChainDataProvider propertyTicker={propertyTicker}>
              {result => {
                const { children = [] } = result || {};
                return (
                  <PropertyInventoriesProvider propertyTickers={children}>
                    <PromotionEditByExcel id={match.params.id} propertyTicker={propertyTicker} />
                  </PropertyInventoriesProvider>
                );
              }}
            </ChainDataProvider>
          </PropertyAdminDataProvider>
        )}
      </Route>
      <Route path={`${url}/extras`}>
        <PropertyAdminDataProvider loader={loader}>
          <ExtrasCrud propertyTicker={propertyTicker} section={SECTION.EXTRAS} />
        </PropertyAdminDataProvider>
      </Route>
      <Route path={`${url}/extras-new`}>
        <PropertyAdminDataProvider loader={loader} loadInventories>
          <ChainDataProvider propertyTicker={propertyTicker}>
            {result => {
              const { children = [] } = result || {};
              return (
                <PropertyInventoriesProvider propertyTickers={children}>
                  <EditExtra section={SECTION.EXTRAS} />
                </PropertyInventoriesProvider>
              );
            }}
          </ChainDataProvider>
        </PropertyAdminDataProvider>
      </Route>
      <Route path={`${url}/extras-copy`}>
        <PropertyAdminDataProvider loader={loader} loadInventories>
          <ChainDataProvider propertyTicker={propertyTicker}>
            {result => {
              const { children = [] } = result || {};
              return (
                <PropertyInventoriesProvider propertyTickers={children}>
                  <EditExtra section={SECTION.EXTRAS} />
                </PropertyInventoriesProvider>
              );
            }}
          </ChainDataProvider>
        </PropertyAdminDataProvider>
      </Route>
      <Route path={`${url}/extras-edit`}>
        <PropertyAdminDataProvider loader={loader} loadInventories>
          <ChainDataProvider propertyTicker={propertyTicker}>
            {result => {
              const { children = [] } = result || {};
              return (
                <PropertyInventoriesProvider propertyTickers={children}>
                  <EditExtra section={SECTION.EXTRAS} />
                </PropertyInventoriesProvider>
              );
            }}
          </ChainDataProvider>
        </PropertyAdminDataProvider>
      </Route>
      <Route path={`${url}/conditions`}>
        {({ match }: RouteComponentProps<TParams>) => (
          <PropertyAdminDataProvider loader={loader} loadConditionLegacyMapping>
            <WitAdminCrudRoutes
              url={match!.url}
              propertyTicker={propertyTicker}
              ListComponent={ConditionsList}
              FormComponent={ConditionsForm}
              section={SECTION.CONDITIONS}
            />
          </PropertyAdminDataProvider>
        )}
      </Route>
      <Route path={`${url}/paymentTypes`}>
        {({ match }: RouteComponentProps<TParams>) => (
          <PropertyAdminDataProvider loader={loader} loadConditionLegacyMapping>
            <WitAdminCrudRoutes
              url={match!.url}
              propertyTicker={propertyTicker}
              ListComponent={PaymentTypesList}
              FormComponent={PaymentTypesForm}
              section={SECTION.PAYMENT_METHODS}
            />
          </PropertyAdminDataProvider>
        )}
      </Route>
      <Route path={`${url}/cancellationPolicy`}>
        {({ match }: RouteComponentProps<TParams>) => (
          <PropertyAdminDataProvider loader={loader} loadConditionLegacyMapping>
            <WitAdminCrudRoutes
              url={match!.url}
              propertyTicker={propertyTicker}
              ListComponent={CancellationPolicyList}
              FormComponent={CancellationPolicyForm}
              section={SECTION.CANCELLATION_POLICY}
            />
          </PropertyAdminDataProvider>
        )}
      </Route>
      <Route path={`${url}/customMapsManager`}>
        <CustomMapsForm section={SECTION.MAPS_MANAGER} propertyTicker={propertyTicker} />
      </Route>
      <Route path={`${url}/tags`}>
        <PropertyAdminDataProvider loader={loader}>
          <TagsContextProvider>
            <TagsList />
          </TagsContextProvider>
        </PropertyAdminDataProvider>
      </Route>
      <Route path={`${url}/tags-multi-update`}>
        <PropertyAdminDataProvider loader={loader}>
          <TagsContextProvider>
            <TagsMultiUpdate />
          </TagsContextProvider>
        </PropertyAdminDataProvider>
      </Route>
      <Route path={`${url}/modification`}>
        {({ match }: RouteComponentProps<TParams>) => (
          <PropertyAdminDataProvider loader={loader} loadConditionLegacyMapping>
            <WitAdminCrudRoutes
              url={match!.url}
              propertyTicker={propertyTicker}
              ListComponent={ModificationList}
              FormComponent={ModificationForm}
              section={SECTION.RESERVATION_MODIFICATION_POLICY}
            />
          </PropertyAdminDataProvider>
        )}
      </Route>
      <Route path={`${url}/display`}>
        {({ match }: RouteComponentProps<TParams>) => (
          <PropertyAdminDataProvider loader={loader}>
            <WitAdminCrudRoutes
              url={match!.url}
              propertyTicker={propertyTicker}
              ListComponent={DisplayList}
              FormComponent={DisplayForm}
              section={SECTION.DISPLAY}
            />
          </PropertyAdminDataProvider>
        )}
      </Route>
      <Route path={`${url}/emailTemplate`}>
        {({ match }: RouteComponentProps<TParams>) => (
          <PropertyAdminDataProvider loader={loader}>
            <WitAdminCrudRoutes
              url={match!.url}
              propertyTicker={propertyTicker}
              ListComponent={EmailTemplateList}
              FormComponent={EmailTemplateForm}
              section={SECTION.CUSTOM_EMAIL}
              isWitAdmin={userAuthInfo?.isWitAdmin}
            />
          </PropertyAdminDataProvider>
        )}
      </Route>
      <Route path={`${url}/questionnaire`}>
        {({ match }: RouteComponentProps<TParams>) => (
          <PropertyAdminDataProvider loader={loader} loadExtraLegacyMapping>
            <WitAdminCrudRoutes
              url={match!.url}
              propertyTicker={propertyTicker}
              ListComponent={QuestionnaireList}
              FormComponent={QuestionnaireForm}
              section={SECTION.QUESTIONNAIRES}
            />
          </PropertyAdminDataProvider>
        )}
      </Route>
      <Route path={`${url}/filter`}>
        {({ match }: RouteComponentProps<TParams>) => (
          <PropertyAdminDataProvider loader={loader}>
            <WitAdminCrudRoutes
              url={match!.url}
              propertyTicker={propertyTicker}
              ListComponent={FilterList}
              FormComponent={FilterForm}
              section={SECTION.FILTERS}
              isWitAdmin={userAuthInfo?.isWitAdmin}
              userProfileEmail={userProfile?.email}
            />
          </PropertyAdminDataProvider>
        )}
      </Route>
      {/*This one is here only for demonstration purposes...*/}
      <Route path={`${url}/legalinfonew`}>
        <LegalInfoCrud propertyTicker={propertyTicker} section={SECTION.LEGAL_INFO} />
      </Route>

      <Route path={`${url}/configurationManager`}>
        {({ match }: RouteComponentProps<TParams>) => {
          return (
            <WitAdminNonCrudWrapper
              url={match!.url}
              propertyTicker={propertyTicker}
              Component={ConfigurationManager}
              section={SECTION.PROPERTY_CONFIGURATION}
            />
          );
        }}
      </Route>
      <Route path={`${url}/priceFeed`}>
        {({ match }: RouteComponentProps<TParams>) => {
          return (
            <WitAdminNonCrudWrapper
              url={match!.url}
              propertyTicker={propertyTicker}
              Component={SelentaPriceFeedForm}
              section={SECTION.PRICE_FEED}
            />
          );
        }}
      </Route>
      <Route path={`${url}/inventoryMultiUpdate`}>
        <InventoryMultiUpdate propertyTicker={propertyTicker} />
      </Route>
      <Route path={`${url}/batch-reservation-cancellation`}>
        <BatchReservationCancellation propertyTicker={propertyTicker} />
      </Route>
      <Route path={`${url}/batch-inventory`}>
        <BatchInventory propertyTicker={propertyTicker} />
      </Route>
      <Route path={`${url}/inventory-table`}>
        <PropertyInventoriesProvider propertyTickers={[propertyTicker]}>
          <InventoryTable propertyTicker={propertyTicker} section={SECTION.INVENTORY_LINES} />
        </PropertyInventoriesProvider>
      </Route>
      <Route path={`${url}/ari-management`}>
        <AuthorizationVerifier section={SECTION.INVENTORY_MANAGEMENT}>
          <SortAndFilterContextProvider>
            <ARIManagement />
          </SortAndFilterContextProvider>
        </AuthorizationVerifier>
      </Route>
      <Route path={`${url}/integrations/analytics-management`}>
        <AnalyticsManager propertyTicker={propertyTicker} section={SECTION.GOOGLE_ANALYTICS} />
      </Route>
      <Route path={`${url}/behaviour`}>
        <Behaviour propertyTicker={propertyTicker} section={SECTION.BEHAVIOR_SETTINGS} />
      </Route>
      <Route path={`${url}/occupancy-types`}>
        <OccupancyForm propertyTicker={propertyTicker} section={SECTION.OCCUPANT_SETTINGS} />
      </Route>
      <Route path={`${url}/billing-report`}>
        <BillingReport propertyTicker={propertyTicker} section={SECTION.BILLING_REPORT} />
      </Route>
      <Route path={`${url}/billing-report-septeo`}>
        <BillingReport
          propertyTicker={propertyTicker}
          section={SECTION.BILLING_REPORT}
          type="septeo"
        />
      </Route>
      <Route path={`${url}/languages`}>
        <LanguageManager propertyTicker={propertyTicker} section={SECTION.LANGUAGE_SETTINGS} />
      </Route>
      <Route path={`${url}/currencies`}>
        <CurrencyManager propertyTicker={propertyTicker} section={SECTION.CURRENCY_SETTINGS} />
      </Route>
      <Route path={`${url}/communication-alerts`}>
        <CommunicationAlerts propertyTicker={propertyTicker} section={SECTION.ALERT_SETTINGS} />
      </Route>
      <Route path={`${url}/engine-guest-data`}>
        <EngineGuestDataForm
          propertyTicker={propertyTicker}
          section={SECTION.CUSTOMER_INFO_SETTINGS}
        />
      </Route>
      <Route path={`${url}/report`}>
        <Report
          propertyTicker={propertyTicker}
          section={SECTION.RESERVATION_STATS}
          type={ReportType.DEFAULT}
        />
      </Route>
      <Route path={`${url}/report-concept`}>
        <Report
          propertyTicker={propertyTicker}
          section={SECTION.RESERVATION_STATS}
          type={ReportType.CONCEPT}
        />
      </Route>
      <Route path={`${url}/report-status`}>
        <Report
          propertyTicker={propertyTicker}
          section={SECTION.RESERVATION_STATS}
          type={ReportType.STATUS}
        />
      </Route>
      <Route path={`${url}/report-stays-per-day`}>
        <ReportStaysPerDay
          propertyTicker={propertyTicker}
          section={SECTION.STAYS_PER_DAY}
          url={url}
        />
      </Route>
      <Route path={`${url}/report-queries`}>
        <ReportQueries propertyTicker={propertyTicker} section={SECTION.QUERY_STATS} />
      </Route>
      <Route path={`${url}/report-queries-bak`}>
        <ReportQueriesBak propertyTicker={propertyTicker} section={SECTION.QUERY_STATS} />
      </Route>
      <Route path={`${url}/waiting-list-report`}>
        <WaitingListReport propertyTicker={propertyTicker} section={SECTION.WAITING_LIST_REPORT} />
      </Route>
    </Switch>
  );
}

interface WitAdminCrudRouteProps {
  url: string;
  propertyTicker?: string;
  ListComponent: React.ComponentType<any>;
  FormComponent: React.ComponentType<any>;
  section?: string;
  userProfileEmail?: string;
  isWitAdmin?: boolean;
}

interface WitAdminNonCrudWrapperProps {
  url: string;
  propertyTicker?: string;
  Component: React.ComponentType<any>;
  section?: string;
  loyaltyAllBrand?: any;
}

function WitAdminNonCrudWrapper({
  url,
  propertyTicker,
  Component,
  section,
  loyaltyAllBrand,
}: WitAdminNonCrudWrapperProps) {
  const history = useHistory();
  const locales = usePropertyLocales();

  const backofficeLocale = getLanguageFromFullLocale(useIntl().locale);
  return (
    <AuthorizationVerifier section={section}>
      <div className="witadmin-bs3 witadmin-bs3-parent">
        <Switch>
          <Route exact path={url}>
            {({ match }: RouteComponentProps<TParams>) => (
              <Component
                history={history}
                success={match?.params.success}
                hotelTicker={propertyTicker}
                locales={locales}
                locale={backofficeLocale}
                loyaltyAllBrand={loyaltyAllBrand?.loyaltyAllBrand}
              />
            )}
          </Route>
        </Switch>
      </div>
    </AuthorizationVerifier>
  );
}

function WitAdminCrudRoutes({
  url,
  ListComponent,
  FormComponent,
  propertyTicker,
  section,
  userProfileEmail,
  isWitAdmin,
}: WitAdminCrudRouteProps) {
  const history = useHistory();
  const locales = usePropertyLocales();
  const backofficeLocale = getLanguageFromFullLocale(useIntl().locale);
  return (
    <AuthorizationVerifier section={section}>
      <div className="witadmin-bs3 witadmin-bs3-parent">
        <Switch>
          <Route exact path={`${url}/:success(success)?`}>
            {({ match }: RouteComponentProps<TParams>) => (
              <ListComponent
                history={history}
                success={match?.params.success}
                hotelTicker={propertyTicker}
                locales={locales}
                locale={backofficeLocale}
                userProfileEmail={userProfileEmail}
                isWitAdmin={isWitAdmin}
              />
            )}
          </Route>
          <Route exact path={`${url}/new`}>
            <FormComponent
              history={history}
              id={null}
              hotelTicker={propertyTicker}
              locales={locales}
              locale={backofficeLocale}
            />
          </Route>
          <Route path={`${url}/:id`}>
            {({ match }: RouteComponentProps<TParams>) => (
              <FormComponent
                history={history}
                id={match?.params.id}
                hotelTicker={propertyTicker}
                locales={locales}
                locale={backofficeLocale}
              />
            )}
          </Route>
        </Switch>
      </div>
    </AuthorizationVerifier>
  );
}
